"use client"

import Image, { type ImageProps } from "next/image"

import { directusImageLoader } from "@/lib/image-utils"

/**
 * next/image for canonical same-origin image URLs, usable from a server
 * component.
 *
 * A server component cannot pass `loader` to next/image directly -- functions
 * are not serializable across the boundary, and the build fails while
 * prerendering. Keeping the loader on this side of a "use client" file lets the
 * server pass only the src string.
 *
 * A src that is not a canonical /img/ path (a third-party image_url, a local
 * /public asset) falls through to Next's own optimizer, unchanged.
 */
export function CanonicalImage(props: ImageProps) {
  const isCanonical =
    typeof props.src === "string" && props.src.startsWith("/img/")

  return <Image {...props} loader={isCanonical ? directusImageLoader : undefined} />
}
